import http from '../http/index';

export const VIDEO_BAN_MESSAGE_KEY = 'ui.common.contact_cs';
export const VIDEO_BAN_MESSAGE = 'Please contact online customer service';

export function isVideoBanned(userInfo) {
  return Number(userInfo && userInfo.video_ban) === 1;
}

export function fetchUserInfo() {
  return http({
    method: 'get',
    url: 'user_info'
  }).then((res) => {
    if (res && res.code === 200) {
      return res.data || {};
    }
    return null;
  }).catch(() => null);
}

export function getVideoBanMessage(userInfo, t) {
  if (!isVideoBanned(userInfo)) {
    return '';
  }
  if (typeof t === 'function') {
    return t(VIDEO_BAN_MESSAGE_KEY);
  }
  return VIDEO_BAN_MESSAGE;
}
